import { createSlice } from '@reduxjs/toolkit';
import { BASE_END_POINT_COMPANY } from '../../../config';
import { getLocalStorageAuthentication } from '../../../lib/auth';

const initialState = {
  activeByJobId: {},
  loadingByJobId: {},
  errorByJobId: {}
};

const benefitSlice = createSlice({
  name: 'benefit',
  initialState,
  reducers: {
    fetchActiveBenefitsStarted: (state, action) => {
      const jobId = action.payload.jobId;
      state.loadingByJobId[jobId] = true;
      state.errorByJobId[jobId] = null;
    },
    fetchActiveBenefitsSucceeded: (state, action) => {
      const { jobId, benefits } = action.payload;
      state.activeByJobId[jobId] = benefits;
      state.loadingByJobId[jobId] = false;
      state.errorByJobId[jobId] = null;
    },
    fetchActiveBenefitsFailed: (state, action) => {
      const { jobId, error } = action.payload;
      state.loadingByJobId[jobId] = false;
      state.errorByJobId[jobId] = error;
    }
  }
});

export const {
  fetchActiveBenefitsStarted,
  fetchActiveBenefitsSucceeded,
  fetchActiveBenefitsFailed
} = benefitSlice.actions;

export const activeBenefitsByJobIdSelector = (state, jobId) =>
  state.benefit.activeByJobId[jobId] || [];
export const activeBenefitsLoadingSelector = (state, jobId) =>
  state.benefit.loadingByJobId[jobId] || false;
export const activeBenefitsErrorSelector = (state, jobId) =>
  state.benefit.errorByJobId[jobId] || null;

export const fetchActiveBenefits = (jobId) => async (dispatch) => {
  if (!jobId) {
    return;
  }

  try {
    dispatch(fetchActiveBenefitsStarted({ jobId }));

    const localAuth = getLocalStorageAuthentication();
    if (!localAuth || !localAuth.token) {
      dispatch(fetchActiveBenefitsSucceeded({ jobId, benefits: [] }));
      return;
    }

    const response = await fetch(
      `${BASE_END_POINT_COMPANY}/api/v1/benefit-duration/job/${jobId}/active`,
      {
        headers: {
          Authorization: `Bearer ${localAuth.token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to load active add-ons');
    }

    const data = await response.json();
    const benefits = data?.data || [];
    dispatch(fetchActiveBenefitsSucceeded({ jobId, benefits }));
  } catch (error) {
    dispatch(
      fetchActiveBenefitsFailed({
        jobId,
        error: error.message
      })
    );
  }
};

export default benefitSlice.reducer;
